import { HoverEffect } from "../ui/card-hover-effect";

export function CardHoverEffectDemo() {
  return (
    <div className="max-w-7xl mx-auto md:px-8">
      <HoverEffect items={projects} />
    </div>
  );
}
export const projects = [
  {
    title: "Scan Global Solutions",
    description:
      "Delivers an extensive range of services including business loan advisory,  startup loans and business immigration aiming to propel small and new businesses towards success.",
    link: "/solutions",
    NetworkImage: "/images/OurNetwork/2.png",
      clickable: true,
  },
  {
    title: "Scan Global Realty",
    description:
      "Specializes  in  international  real  estate  investments, focusing on lucrative markets in Dubai, Mexico, Turkey, and the USA to offer exceptional opportunities",
    link: "/realty",
    NetworkImage: "/images/OurNetwork/3.png",
      clickable: true,
  },
  {
    title: "Scan Accounting",
    description:
      "Provides comprehensive tax, accounting, and bookkeeping services, utilizing a team of seasoned professionals to support various industries.",
    // link: "",
    NetworkImage: "/images/OurNetwork/1.png",
      clickable: false,
  },
  {
    title: "Scan Business Brokerage",
    description:
      "Renowned  for  expertise  in  commercial  real  estate, franchising,  and  business  transactions,  offering  tailored advice to navigate complex deals.",
    // link: "",
    NetworkImage: "/images/OurNetwork/4.png",
      clickable: false,
  },
  // {
  //   title: "Scan Analytics",
  //   description:
  //     "Specializes in enhancing client operations through data analytics and intelligent automation, leveraging the latest technologies for business process improvement.",
  //   // link: "",
  //   NetworkImage: "/images/OurNetwork/5.png",
  //     clickable: false,
  // },
  // {
  //   title: "Scan HR Solutions",
  //   description:
  //     "Offers a broad spectrum of training programs in Financial and  Business  Management,  IT,  and  Business  Skills  to boost professional growth",
  //   // link: "",
  //   NetworkImage: "/images/OurNetwork/6.png",
  //     clickable: false,
  // },
];
